import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth'
import { firestorePlugin } from 'vuefire'
import VueCookie from 'vue-cookie'
import VueResource from "vue-resource"
import VueScrollReveal from 'vue-scroll-reveal';


Vue.config.productionTip = false
Vue.use(firestorePlugin);
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 1000,
  scale: 1,
  distance: '20px',
  mobile: true,
  reset: false
})

const firebaseConfig = {
  apiKey: "AIzaSyDOVmgELHMVBXZ4hRC4CYA5umUQzw971Lk",
  authDomain: "dragonainvest.firebaseapp.com",
  databaseURL: "https://dragonainvest.firebaseio.com",
  projectId: "dragonainvest",
  storageBucket: "dragonainvest.appspot.com",
  messagingSenderId: "196039367578",
  appId: "1:196039367578:web:d9d173a3d0a35c43"
};

firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

firebase.auth().onAuthStateChanged(() => {
  new Vue({
    router,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
});

